import Button from 'react-bootstrap/Button'

const CustomCloseButton = ({ text = '', onClick, variant = 'secondary' }) => {
  return (
    <Button
      type="button"
      onClick={onClick}
      variant={variant}
      className="btn text-muted"
      style={{ backgroundColor: 'transparent', border: 'none' }}
    >
      {text ? text : 'Close'}
    </Button>
  )
}

export default CustomCloseButton
